import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import {  useEffect, useMemo, useState } from "react";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns } from "js/requireCheck";
import BasicButton from "components/button/BasicButton";
import { sendDelete, sendGet, sendPost, sendPut } from "api/restUtil";
import ReactDataTableModifiable from "components/DataTable/ReactDataTableModifiable";
import ReactDataTableDisplay from "components/DataTable/ReactDataTableDisplay";
import { delConfirm, modConfirm, saveConfirm } from "js/common";

/**
 * 지점 옵션수정 팝업
 */
function BranchOptionModModal (props) {

	const { isOpen, onClose, initData, modalId, title } = props;
	// const [ origData, setOrigData ] = useState({});	// return 형태가 nextOptionId와 데이터 목록으로 구성되어 있음. 이거 전체를 담는 Object
	const [ data, setData ] = useState([]);	// 데이터 목록만 담을 Object
	// const [ dataSend, setDataSend ] = useState({});	// 테이블에서 넘어온 데이터
	const [ selectRows, setSelectRows ] = useState([]);	// 테이블에서 넘어온 데이터
	// const [ deletedRows, setDeletedRows ] = useState([]);
	
	// 신규 등록 관련
	const [ emptyData, setEmptyData ] = useState([]);	// 신규 등록시 넘길 빈 데이터
	const [ showAdd, setShowAdd ] = useState(false);
	const [ branchOptionAddRow, setBranchOptionAddRow ] = useState(null);
	const [ branchOptionDelRow, setBranchOptionDelRow ] = useState(null);
	const [ addDatas, setAddDatas ] = useState([]);
	const [ selectAddRows, setSelectAddRows ] = useState([]);

	// 수정 관련
	const [ showMod, setShowMod ] = useState(false);
	const [ modDatas, setModDatas ] = useState(false);
	
	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		{ header : "No", col : "ordr", cellWidth: "30", },
		{ header : "ID", col : "id", cellWidth: "50", },
		{ header : "지점ID", col : "branchId", cellWidth: "100"},
		{ header : "재고", col : "stockQuantity", cellWidth: "100"},
		{ header : "옵션가", col : "price", cellWidth: "100", type: "number" },
		{ header : "사용여부", col : "usable", cellWidth : "100"},
	], []);
	const mgmtColumns = useMemo(() =>[
		{ header : "No", col : "ordr", cellWidth: "30", },
		{ header : "ID", col : "id", cellWidth: "50", },
		{ header : "지점ID", col : "branchId", cellWidth: "100", type: "text", mod: true, require: true},
		{ header : "재고", col : "stockQuantity", cellWidth: "100", type: "number", mod: true, require: true},
		{ header : "옵션가", col : "price", cellWidth: "100", type: "decimal", decimalPlaceCnt: 0, mod: true, require: true},
		{ header : "사용여부", col : "usable", cellWidth : "100", type: "select", mod: true, require: true,
			option: [
				{label: "선택하세요", value: ""},
				{label: "사용", value: "true"},
				{label: "미사용", value: "false"},
			],},
	], []);

	
	useEffect(() => {
		if(!isOpen) {
			setData([]);
			hideAddPanel();
			hideModPanel();
			
			return;
		};
		
		if(isOpen && initData && initData.channelProductNo) getBranchOptionData(initData);

	}, [isOpen, initData]);
	
	// 기존 정보 조회
	const getBranchOptionData = async (productData) => {
		// 원래 페이징이 있는데 우리는 개수가 많지 않아서 그냥 가는걸로...
		const result = await sendGet("/api/mgmt/product/branchOption/" + productData.channelProductNo, {});
		if(result.respCode == "SUCCESS") {
			// setData(result.data);
			
			if(result.data == null || result.data.options == null) {
				setData([]);
				return;
			}

			const ordrData = result.data.options.map((d, idx) => ({...d, ordr: idx+1}));
			setData(ordrData);
		} else {
			alert("지점 옵션 조회 실패");
			return;
		}
	}

	// 신규 등록 관련 START
	//행 추가 버튼
	const onAddRow = () => {
		const newRow = {};
		const ordrArr = addDatas.map(d => d.ordr);
		const maxOrdr = ordrArr.length == 0 ? 1 : Math.max(...ordrArr) + 1;
		newRow.ordr = maxOrdr;
		setBranchOptionAddRow(newRow);
	}

	// 행 삭제 버튼
	const onDelRow = () => {
		setBranchOptionDelRow(selectAddRows.map(r => ({ordr: r.ordr})));
	}

	// 순서 변경
	const resetOrdr = (changedData) => {
		changedData.forEach((d, idx) => {
			d.ordr = idx + 1;
		});
		setAddDatas(changedData);
	}

	// 신규 데이터 등록
	const saveAddDatas = async () => {

		// // 필수 체크 (표)
		if(!checkRequiredAndInvalid(mgmtColumns, addDatas, "#branchOptionAddTable")) return;

		if(!saveConfirm()) return;

		const sendData = {options: addDatas};
		const result = await sendPost("/api/mgmt/product/branchOption/" + initData.channelProductNo, sendData);
		if(result.respCode === "SUCCESS") {
			alert("요청하였습니다. 비동기 처리 이므로 처리 결과를 반드시 확인해 주세요.");
			getBranchOptionData(initData);
		}
	}
	// 신규 등록 판넬 닫기
	const hideAddPanel = () => {
		setShowAdd(false);
		setBranchOptionAddRow(null);
		setBranchOptionDelRow(null);
		setAddDatas([]);
		setSelectAddRows([]);
	};

	useEffect(() => {
		checkAndRemoveInvalid(addDatas, "#branchOptionAddTable");
	}, [addDatas]);
	// 신규 등록 관련 END

	// 수정 관련 START
	// 수정 데이터 등록
	const saveModDatas = async () => {

		// // 필수 체크 (표)
		if(!checkRequiredAndInvalid(mgmtColumns, modDatas, "#branchOptionModTable")) return;
		
		if(!modConfirm()) return;

		const sendData = {options: modDatas};
		const result = await sendPut("/api/mgmt/product/branchOption/" + initData.channelProductNo, sendData);
		if(result.respCode === "SUCCESS") {
			alert("요청하였습니다. 비동기 처리 이므로 처리 결과를 반드시 확인해 주세요.");
			getBranchOptionData(initData);
		}
	}
	// 수정 판넬 닫기
	const hideModPanel = () => {
		setShowMod(false);
	};
	// 수정 관련 END


	// 삭제 버튼
	const delSelectedRow = async () => {
		if(selectRows.length === 0) return;

		if(!delConfirm()) return;

		const delOptionIds = selectRows.map(r => r.id);
		
		const sendData = {optionIds: delOptionIds};
		const result = await sendDelete("/api/mgmt/product/branchOption/" + initData.channelProductNo, sendData);
		if(result.respCode === "SUCCESS") {
			alert("삭제 되었습니다.");
			getBranchOptionData(initData);
		}
	}


	// 처리결과 확인
	const checkModBranchOptions = async () => {
		const result = await sendGet("/api/mgmt/product/branchOption/" + initData.channelProductNo + "/asyncStatus");
		if(result.respCode === "SUCCESS") {
			if(result.data === "SUCCESS") {
				alert("정상 처리 되었습니다.");
			} else {
				alert(result.data);
			}
		}
	}

	const updateDb = async () => {
		const sendData = {options: data};
		const result = await sendPost("/api/mgmt/product/branchOption/" + initData.channelProductNo + "/insertDb", sendData);
		if(result.respCode === "SUCCESS") {
			alert("저장 되었습니다.");
		}
	}

	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={title + "팝업"}
			id={modalId}
		>
			<div className="me-modal">
				<div className="me-modal-container" style={{width: "1000px", height: "600px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">{title}</h4>
						</div>

						<div className="me-modal-body" style={{overflowY: "scroll"}} >	{/* 달력때문에 overflow visible설정 */}
							{/* <div className="body-area modal-form" id="branchOptionModModal"> */}
								<div className="burgundy" style={{width: "100%", textAlign: "left"}}>
									※ 등록/수정시에는 반드시 처리결과를 확인해 주시고, 성공시에는 DB등록 버튼을 눌러서 데이터를 갱신해 주세요.
								</div>
								<div className="table-buttons mg-t-10 mg-b-10">
									<BasicButton label="신규" className="btn-add" disabled={showAdd || showMod} onClick={() => setShowAdd(true)} />
									<BasicButton label="수정" className="btn-mod" disabled={showAdd || showMod} onClick={() => setShowMod(true)} />
									<BasicButton label="삭제" className="btn-del" disabled={showAdd || showMod || selectRows.length === 0} onClick={() => delSelectedRow()} />
									<BasicButton label="처리결과 (마지막 등록 또는 수정)" className="btn-save" onClick={checkModBranchOptions} />
									<BasicButton label="DB등록" className="btn-copy" disabled={showAdd || showMod} onClick={updateDb} />
								</div>
								{!showMod && (
									<ReactDataTableDisplay
										columns={columns}
										customDatas={data}
										hideCheckBox={false}
										returnSelectRows={(selects) =>  setSelectRows(selects)}
										percentageWidth={true}
										maxHeight="250px"
									/>
								)}
								{showMod && (
									<>
										<h2>수정</h2>
										<div className="table-buttons mg-t-10 mg-b-10">
											<div className="burgundy" style={{width: "100%", textAlign: "left"}}>
												※ 지점ID가 부정확해도 저장됩니다. 정확히 입력해 주세요. <br />
												※ 옵션가는 상품 기본가격에서 +- 되는 가격이며, 10원 단위로 입력 가능합니다.
											</div>
											<BasicButton label="저장" className="btn-save" disabled={modDatas.length === 0} onClick={() => saveModDatas()} />
											<BasicButton label="닫기" className="btn-cancel" onClick={() => hideModPanel()} />
										</div>
										<ReactDataTableModifiable
											dataTableId="branchOptionModTable"
											columns={mgmtColumns}
											customDatas={data}
											hideCheckBox={true}
											dataSend={setModDatas}
											percentageWidth={true}
											maxHeight="250px"
										/>
									</>
								)}

								{showAdd && (
									<>
										<div className="hr"></div>
										<h2>신규</h2>
										<div className="table-buttons mg-t-10 mg-b-10">
											<div className="burgundy" style={{width: "100%", textAlign: "left"}}>
												※ 지점ID가 부정확해도 저장됩니다. 정확히 입력해 주세요. <br />
												※ 옵션가는 상품 기본가격에서 +- 되는 가격이며, 10원 단위로 입력 가능합니다.
											</div>
											<BasicButton label="저장" className="btn-save" disabled={addDatas.length === 0} onClick={() => saveAddDatas()} />
											<BasicButton label="닫기" className="btn-cancel" onClick={() => hideAddPanel()} />
											<BasicButton label="행추가" className="btn-add" onClick={() => onAddRow()} />
											<BasicButton label="행삭제" className="btn-del" disabled={selectAddRows.length === 0} onClick={() => onDelRow()} />
										</div>
										<ReactDataTableModifiable
											dataTableId="branchOptionAddTable"
											columns={mgmtColumns}
											customDatas={emptyData}
											addRow={branchOptionAddRow}
											delRow={branchOptionDelRow}
											delRowComplete={resetOrdr}
											hideCheckBox={false}
											returnSelectRows={(selects) => setSelectAddRows(selects)}
											dataSend={setAddDatas}
											percentageWidth={true}
											maxHeight="250px"
										/>
									</>
								)}
								
							{/* </div> */}

						</div>

						<div className="me-modal-footer mg-b-20" style={{marginTop: "auto"}}>
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="닫기" className="btn-cancel" onClick={onClose} style={{width: "100%"}} />
								{/* <BasicButton label="확인" className="btn-save" onClick={onClickOk} style={{width: "100%"}} /> */}
							</div>
						</div>

					</div>

				</div>
			</div>
		</ReactModal>
	);
}

export default BranchOptionModModal;
